import { render, staticRenderFns } from "./sumParamsModal.vue?vue&type=template&id=afed8854&scoped=true"
import script from "./sumParamsModal.vue?vue&type=script&lang=js"
export * from "./sumParamsModal.vue?vue&type=script&lang=js"
import style0 from "./sumParamsModal.vue?vue&type=style&index=0&id=afed8854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afed8854",
  null
  
)

export default component.exports